'use client';

import { c as _c } from "react/compiler-runtime";
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import useModalStore from '@module/stores/useModalStore';
import { MyMenu_19Certi, MyMenuMessage, MyMenuMyheart } from '@module/svg/icons';
import { MODAL_TYPE_PC } from '@module/types/modal/type';
import formatNumberWithComma from '@module/utils/formatNumberWithComma';
import { DropdownMenuItem } from '@pc/components/ui/dropdown-menu';
import { useRouter } from 'next/navigation';
function UserCoinsMenuItem() {
  const $ = _c(24);
  const router = useRouter();
  const {
    userInfo,
    isPostAvailable
  } = useGetLoginInfoQuery();
  const {
    pushModal
  } = useModalStore();
  let t0;
  if ($[0] !== pushModal) {
    t0 = () => {
      pushModal({
        type: MODAL_TYPE_PC.IDENTITY_VERIFICATION_MODAL,
        id: "UserCoinsMenuItem"
      });
    };
    $[0] = pushModal;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const openVerificationModal = t0;
  let t1;
  if ($[2] !== router) {
    t1 = () => router.push("/my/heart/used");
    $[2] = router;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MyMenuMyheart className="h-[18px] w-[18px]" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== userInfo?.coinHave) {
    t3 = userInfo?.coinHave && `${formatNumberWithComma(userInfo?.coinHave)}`;
    $[5] = userInfo?.coinHave;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <span className="text-[13px] text-mainColor">{t3}개</span>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <DropdownMenuItem className="flex flex-1 cursor-pointer flex-col items-center justify-center gap-[5px] hover:outline-none data-[highlighted]:bg-transparent" onClick={t1}>{t2}{t4}</DropdownMenuItem>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== isPostAvailable || $[13] !== router || $[14] !== userInfo?.coinHave || $[15] !== userInfo?.postCountReadN) {
    t6 = isPostAvailable && <DropdownMenuItem className="flex flex-1 cursor-pointer flex-col items-center justify-center gap-[5px] hover:outline-none data-[highlighted]:bg-transparent" onClick={() => router.push("/my/post/received")}><MyMenuMessage className="h-[18px] w-[18px]" /><span className="text-[13px] text-mainColor">{userInfo?.coinHave && `${formatNumberWithComma(userInfo?.postCountReadN)}`}개</span></DropdownMenuItem>;
    $[12] = isPostAvailable;
    $[13] = router;
    $[14] = userInfo?.coinHave;
    $[15] = userInfo?.postCountReadN;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== openVerificationModal || $[18] !== userInfo?.isAdult) {
    t7 = !userInfo?.isAdult && <DropdownMenuItem className="flex flex-1 cursor-pointer flex-col items-center justify-center gap-[5px] hover:outline-none data-[highlighted]:bg-transparent" onClick={openVerificationModal}><MyMenu_19Certi style={{
        fontSize: 10
      }} /><span className="text-[13px] text-mainColor">인증하기</span></DropdownMenuItem>;
    $[17] = openVerificationModal;
    $[18] = userInfo?.isAdult;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <div className="flex border-colorBg23 border-b pt-4 pb-3">{t5}{t6}{t7}</div>;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
}
export default UserCoinsMenuItem;